import { render } from "./PathwayMappingTemplateList.vue?vue&type=template&id=72c38447&scoped=true"
import script from "./PathwayMappingTemplateList.vue?vue&type=script&lang=js"
export * from "./PathwayMappingTemplateList.vue?vue&type=script&lang=js"

import "./PathwayMappingTemplateList.vue?vue&type=style&index=0&id=72c38447&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c38447"],['__file',"resources/js/components/admin/PathwayMappingTemplateList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72c38447"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72c38447', __exports__)) {
    api.reload('72c38447', __exports__)
  }
  
  module.hot.accept("./PathwayMappingTemplateList.vue?vue&type=template&id=72c38447&scoped=true", () => {
    api.rerender('72c38447', render)
  })

}


export default __exports__